import React from 'react';

export default class StorefrontErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Storefront render error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            fontFamily: "'Open Sans', sans-serif",
            color: '#355062',
            background: '#fff9fa',
            textAlign: 'center',
          }}
        >
          <div>
            <h1 style={{ fontFamily: "'Sulphur Point', sans-serif", margin: '0 0 12px' }}>
              Raheasy is temporarily unavailable
            </h1>
            <p style={{ margin: '0 0 20px', color: '#5c6f7f' }}>
              Something went wrong loading the storefront. Please try again.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                background: '#355062',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '10px 18px',
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
